export interface HeroSlide {
  id: number;
  movieId: number;
  title: string;
  tagline: string;
  tag: string;
  meta: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 1,
    movieId: 1,
    title: '星海远征',
    tagline: '穿越虫洞，只为在星海尽头为人类找到第二个家。',
    tag: '本周焦点',
    meta: '科幻 · 冒险 · 2024 · 中国大陆',
    image:
      'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20a%20lone%20spaceship%20traveling%20toward%20a%20glowing%20violet%20nebula%2C%20deep%20navy%20and%20teal%20tones%2C%20cinematic%20wide%20composition%2C%20dramatic%20lighting%2C%20highly%20detailed&width=1600&height=900&seq=hero-1&orientation=landscape',
  },
  {
    id: 2,
    movieId: 2,
    title: '长夜将至',
    tagline: '小镇的秘密，比夜色更漫长。',
    tag: '口碑懸疑',
    meta: '悬疑 · 犯罪 · 2024 · 全24集',
    image:
      'https://readdy.ai/api/search-image?query=Atmospheric%20noir%20rainy%20city%20street%20at%20night%20with%20reflective%20wet%20asphalt%20and%20warm%20amber%20streetlights%2C%20deep%20blue%20tones%2C%20cinematic%20wide%20composition%2C%20moody%20and%20dramatic&width=1600&height=900&seq=hero-2&orientation=landscape',
  },
  {
    id: 3,
    movieId: 9,
    title: '机甲纪元',
    tagline: '废墟之上，钢铁与少年一同苏醒。',
    tag: '动画力作',
    meta: '动画 · 科幻 · 2025 · 日本',
    image:
      'https://readdy.ai/api/search-image?query=Stunning%20anime%20mecha%20scene%2C%20giant%20robot%20silhouette%20against%20a%20fiery%20orange%20sunset%20over%20a%20ruined%20city%2C%20vivid%20warm%20tones%2C%20cinematic%20wide%20composition%2C%20highly%20detailed&width=1600&height=900&seq=hero-3&orientation=landscape',
  },
  {
    id: 4,
    movieId: 16,
    title: '北极星',
    tagline: '在抵达之前，每个人都必须做出选择。',
    tag: '年度科幻',
    meta: '科幻 · 剧情 · 2025 · 英国',
    image:
      'https://readdy.ai/api/search-image?query=Space%20station%20orbiting%20a%20bright%20star%20above%20a%20frozen%20planet%2C%20cold%20silver%20blue%20and%20pale%20gold%20tones%2C%20epic%20cinematic%20wide%20composition%2C%20dramatic%20and%20serene&width=1600&height=900&seq=hero-4&orientation=landscape',
  },
];